export default __webpack_public_path__ + "static/media/002-sad.d45dcbbc.svg";